import _ from 'lodash';
import { Component, PureComponent } from 'react';
import { Collapse } from 'reactstrap';
import classnames from 'classnames';
import { connect } from 'react-redux';
import RequiresRole from 'flaivy-react/components/RequiresRole';
import PropTypes from 'prop-types';
import domainModel from 'domain-model';
import Link from 'next/link';
import Image from 'next/image';

import { toggleSidebar as _toggleSidebar } from '../shared/actions/navigation.actions';
import RequiresSubscriptionLevel from 'flaivy-react/components/RequiresSubscriptionLevel';

class CollapseMenu extends Component {
  static get propTypes() {
    return {
      icon: PropTypes.string.isRequired,
      children: PropTypes.array.isRequired,
      third: PropTypes.bool,
      title: PropTypes.string.isRequired,
    };
  }

  static get defaultProps() {
    return {
      third: false,
    };
  }

  constructor(props) {
    super(props);
    this.toggle = this.toggle.bind(this);
    this.state = { isCollapsed: false };
  }

  toggle() {
    this.setState(state => ({ isCollapsed: !state.isCollapsed }));
  }

  render() {
    const {
      state: { isCollapsed },
      props: { third, icon, title, children },
    } = this;
    const listClasses = classnames({
      'menuitem-active': isCollapsed,
      'side-nav-item': true,
    });
    const aclasses = classnames({
      'side-nav-link': !third,
      'side-nav-item': third,
    });
    const liclasses = classnames({
      'side-nav-second-level': !third,
      'side-nav-third-level': third,
    });
    return (
      <li className={listClasses}>
        {/* eslint-disable-next-line */}
        <a onClick={this.toggle} className={aclasses}>
          <i className={classnames({ [`dripicons-${icon}`]: true })} />
          <span> {title} </span>
          <span className="menu-arrow" />
        </a>
        <Collapse isOpen={isCollapsed}>
          <ul className={liclasses}>{children}</ul>
        </Collapse>
      </li>
    );
  }
}

class Sidebar extends PureComponent {
  static get propTypes() {
    return {
      toggleSidebar: PropTypes.func.isRequired,
      sessionUser: PropTypes.object.isRequired,
    };
  }

  render() {
    const toggle = () => {
      this.props.toggleSidebar();
    };
    const { sessionUser } = this.props;

    const usesSupplierCustomer = _.get(
      sessionUser,
      'organization.usesSupplierCustomer',
      false,
    );
    const isUsingCrm = _.get(sessionUser, 'organization.isUsingCrm', false);
    const hasCopackAgreement = _.get(
      sessionUser,
      'organization.hasCopackAgreement',
      false,
    );

    return (
      <div className="leftside-menu">
        <Link href="/app/" className="logo logo-light">
          <span
            className="logo-lg"
            style={{
              position: 'relative',
              height: '70px',
              width: '125px',
              margin: '0 auto',
            }}
          >
            <Image src="/static/images/qvanti_white.svg" alt="" layout="fill" />
          </span>
          <span className="logo-sm">
            <Image
              src="/static/images/qvanti_white.svg"
              alt=""
              height={16}
              width={75}
            />
          </span>
        </Link>

        <div className="h-100" id="leftside-menu-container">
          <ul className="side-nav">
            <li className="side-nav-title side-nav-item">Navigation</li>

            <RequiresRole
              requiredRoles={[
                'super',
                'supplier',
                'qvantiSupplierRoleOrderAcceptance',
              ]}
            >
              <li className="side-nav-item">
                <Link
                  href="/app/"
                  onClick={toggle}
                  onKeyPress={toggle}
                  role="link"
                  className="side-nav-link"
                >
                  <i className="dripicons-graph-line" /> Dashboards
                </Link>
              </li>
            </RequiresRole>
            <RequiresRole
              requiredRoles={[
                'super',
                'supplier',
                'qvantiSupplierRoleOrderAcceptance',
              ]}
            >
              <li className="side-nav-item">
                <Link
                  href="/app/orders?query[cancelled]=false"
                  id="orderslink"
                  onClick={toggle}
                  onKeyPress={toggle}
                  role="link"
                  className="side-nav-link"
                >
                  <i className="dripicons-shopping-bag" /> Orderhantering
                </Link>
              </li>
            </RequiresRole>
            <RequiresRole
              requiredRoles={[
                'super',
                'supplier',
                'qvantiSupplierRoleOrderAcceptance',
                'qvantiSupplierRolePriceChanges',
              ]}
            >
              <li className="side-nav-item">
                <Link
                  href="/app/price-lists?query[active]=true&query[isListPriceList]=false"
                  onClick={toggle}
                  onKeyPress={toggle}
                  role="link"
                  className="side-nav-link"
                >
                  <i className="dripicons-view-list" /> Prislistor
                </Link>
              </li>
            </RequiresRole>
            {sessionUser.hasSettlementAccess && (
              <RequiresRole requiredRoles={['supplier']}>
                <li className="side-nav-item">
                  <Link
                    href="/app/settlements?query[cancelled]=false"
                    onClick={toggle}
                    onKeyPress={toggle}
                    role="link"
                    className="side-nav-link"
                  >
                    <i className="dripicons-document" /> Avräkningar
                  </Link>
                </li>
              </RequiresRole>
            )}
            <RequiresRole requiredRoles={['super']}>
              <li className="side-nav-item">
                <Link
                  href="/app/settlements?query[cancelled]=false"
                  onClick={toggle}
                  onKeyPress={toggle}
                  role="link"
                  className="side-nav-link"
                >
                  <i className="dripicons-document" /> Avräkningar
                </Link>
              </li>
            </RequiresRole>
            <RequiresRole
              requiredRoles={[
                'super',
                'supplier',
                'qvantiSupplierRoleOrderAcceptance',
                'qvantiSupplierRoleArticleChanges',
                'qvantiSupplierRolePriceChanges',
              ]}
            >
              <li className="side-nav-item">
                <Link
                  href="/app/articles?query[active]=true"
                  onClick={toggle}
                  onKeyPress={toggle}
                  role="link"
                  className="side-nav-link"
                >
                  <i className="dripicons-store" /> Artiklar
                </Link>
              </li>
            </RequiresRole>
            <RequiresRole requiredRoles={['super']}>
              <li className="side-nav-item">
                <Link
                  href={'/app/customer-sub-units?query[active]=true'}
                  onClick={toggle}
                  onKeyPress={toggle}
                  role="link"
                  className="side-nav-link"
                >
                  <i className="dripicons-user-group" /> Centralt kundregister
                </Link>
              </li>
            </RequiresRole>
            <RequiresRole
              requiredRoles={[
                'supplier',
                'qvantiSupplierRoleOrderAcceptance',
                'qvantiSupplierRolePriceChanges',
                'qvantiSupplierRoleCustomerChanges',
              ]}
            >
              {!usesSupplierCustomer && (
                <li className="side-nav-item">
                  <Link
                    href={'/app/customer-sub-units?query[active]=true'}
                    onClick={toggle}
                    onKeyPress={toggle}
                    role="link"
                    className="side-nav-link"
                  >
                    <i className="dripicons-user-group" /> Centralt kundregister
                  </Link>
                </li>
              )}
              {usesSupplierCustomer && (
                <li className="side-nav-item">
                  <Link
                    href={'/app/supplier-customers?query[active]=true'}
                    onClick={toggle}
                    onKeyPress={toggle}
                    role="link"
                    className="side-nav-link"
                  >
                    <i className="dripicons-user-group" /> Mina kunder
                  </Link>
                </li>
              )}
            </RequiresRole>
            {isUsingCrm && (
              <RequiresRole
                requiredRoles={[
                  'super',
                  'supplier',
                  'qvantiSupplierRoleOrderAcceptance',
                  'qvantiSupplierRoleCustomerChanges',
                ]}
              >
                <li className="side-nav-item">
                  <Link
                    href="/app/activities?query[isDone]=false&search="
                    onClick={toggle}
                    onKeyPress={toggle}
                    role="link"
                    className="side-nav-link"
                  >
                    <i className="dripicons-to-do" /> Mina aktiviteter
                  </Link>
                </li>
              </RequiresRole>
            )}
            <RequiresRole
              requiredRoles={[
                'super',
                'supplier',
                'qvantiSupplierRoleOrderAcceptance',
                'qvantiSupplierRoleArticleChanges',
              ]}
            >
              <li className="side-nav-item">
                <Link
                  href="/app/brands?query[active]=true"
                  onClick={toggle}
                  onKeyPress={toggle}
                  role="link"
                  className="side-nav-link"
                >
                  <i className="dripicons-message" /> Varumärken
                </Link>
              </li>
            </RequiresRole>
            {hasCopackAgreement && (
              <RequiresRole requiredRoles={['super', 'supplier']}>
                <li className="side-nav-item">
                  <Link
                    href="/app/purchase-orders?query[cancelled]=false"
                    onClick={toggle}
                    onKeyPress={toggle}
                    role="link"
                    className="side-nav-link"
                  >
                    <i className="dripicons-cart" /> Inleverans
                  </Link>
                </li>
              </RequiresRole>
            )}
            <RequiresRole requiredRoles={['super', 'supplier']}>
              <li className="side-nav-item">
                <Link
                  href="/app/reports"
                  onClick={toggle}
                  onKeyPress={toggle}
                  role="link"
                  className="side-nav-link"
                >
                  <i className="dripicons-graph-line" /> Rapporter
                </Link>
              </li>
            </RequiresRole>
            <RequiresRole requiredRoles={['super']}>
              <li className="side-nav-item">
                <Link
                  href="/app/invoices?query[cancelled]=false"
                  onClick={toggle}
                  onKeyPress={toggle}
                  role="link"
                  className="side-nav-link"
                >
                  <i className="dripicons-ticket" /> Fakturahantering
                </Link>
              </li>
            </RequiresRole>
            <RequiresRole requiredRoles={['super']}>
              <li className="side-nav-item">
                <Link
                  href="/app/changes"
                  onClick={toggle}
                  onKeyPress={toggle}
                  role="link"
                  className="side-nav-link"
                >
                  <i className="dripicons-clock" /> Historik
                </Link>
              </li>
            </RequiresRole>
            <RequiresRole requiredRoles={['super']}>
              <li className="side-nav-item">
                <Link
                  href="/app/suppliers?query[active]=true"
                  onClick={toggle}
                  onKeyPress={toggle}
                  role="link"
                  className="side-nav-link"
                >
                  <i className="dripicons-thumbs-up" /> Leverantörer
                </Link>
              </li>
            </RequiresRole>
            <RequiresRole
              requiredRoles={['supplier', 'qvantiSupplierRoleArticleChanges']}
            >
              {usesSupplierCustomer && (
                <li className="side-nav-item">
                  <Link
                    href="/app/suppliers?query[active]=true"
                    onClick={toggle}
                    onKeyPress={toggle}
                    role="link"
                    className="side-nav-link"
                  >
                    <i className="dripicons-thumbs-up" /> Leverantörer
                  </Link>
                </li>
              )}
            </RequiresRole>
            {usesSupplierCustomer && (
              <RequiresSubscriptionLevel
                requiredSubscriptionLevel={'flaivyplus'}
              >
                <RequiresRole
                  requiredRoles={[
                    'supplier',
                    'qvantiSupplierRoleArticleChanges',
                  ]}
                >
                  <li className="side-nav-item">
                    <Link
                      href="/app/labels?query[active]=true"
                      onClick={toggle}
                      onKeyPress={toggle}
                      role="link"
                      className="side-nav-link"
                    >
                      <i className="dripicons-tags" /> Etiketter
                    </Link>
                  </li>
                </RequiresRole>
              </RequiresSubscriptionLevel>
            )}
            {!usesSupplierCustomer /* TODO: change check to onCopack */ && (
              <RequiresRole requiredRoles={['super', 'supplier']}>
                <li className="side-nav-item">
                  <Link
                    href="/app/complaints?query[cancelled]=false"
                    onClick={toggle}
                    onKeyPress={toggle}
                    role="link"
                    className="side-nav-link"
                  >
                    <i className="dripicons-thumbs-down" /> Reklamationer{' '}
                  </Link>
                </li>
              </RequiresRole>
            )}
            {usesSupplierCustomer && (
              <RequiresRole
                requiredRoles={['supplier', 'qvantiSupplierRoleArticleChanges']}
              >
                <li className="side-nav-item">
                  <Link
                    href="/app/export-import"
                    onClick={toggle}
                    onKeyPress={toggle}
                    role="link"
                    className="side-nav-link"
                  >
                    <i className="dripicons-upload" /> Export / Import
                  </Link>
                </li>
              </RequiresRole>
            )}
            <RequiresRole
              requiredRoles={['supplier', 'qvantiSupplierRoleSupplierAdmin']}
            >
              <CollapseMenu title="Administration" icon="user">
                <RequiresRole requiredRoles={['supplier']}>
                  {usesSupplierCustomer && (
                    <li>
                      <Link
                        href="/app/shop-users"
                        onClick={toggle}
                        onKeyPress={toggle}
                        role="link"
                      >
                        Kundanvändare
                      </Link>
                    </li>
                  )}
                  <RequiresSubscriptionLevel
                    requiredSubscriptionLevel={
                      domainModel.organization.subscriptionLevels.enterprise
                    }
                  >
                    <li>
                      <Link
                        href="/app/category-trees"
                        onClick={toggle}
                        onKeyPress={toggle}
                        role="link"
                      >
                        Kategorier
                      </Link>
                    </li>
                  </RequiresSubscriptionLevel>
                </RequiresRole>
                <RequiresRole
                  requiredRoles={['qvantiSupplierRoleSupplierAdmin']}
                >
                  <li>
                    <Link href="/app/integrations/?query[active]=true">
                      Integrationer
                    </Link>
                  </li>
                  <li>
                    <Link
                      href="/app/users"
                      onClick={toggle}
                      onKeyPress={toggle}
                      role="link"
                    >
                      Mina användare
                    </Link>
                  </li>
                  <li>
                    <Link href="/app/shop-configs/?query[active]=true">
                      Min webbshop
                    </Link>
                  </li>
                </RequiresRole>
              </CollapseMenu>
            </RequiresRole>
            <RequiresRole requiredRoles={['super']}>
              <CollapseMenu title="Administration" icon="user">
                <li>
                  <Link
                    href="/app/users"
                    onClick={toggle}
                    onKeyPress={toggle}
                    role="link"
                  >
                    Leverantörsanvändare
                  </Link>
                </li>
                <li>
                  <Link
                    href="/app/shop-users"
                    onClick={toggle}
                    onKeyPress={toggle}
                    role="link"
                  >
                    Kundanvändare
                  </Link>
                </li>
                <li>
                  <Link
                    href="/app/organizations?query[active]=true"
                    onClick={toggle}
                    onKeyPress={toggle}
                    role="link"
                  >
                    Leverantörsorganisationer
                  </Link>
                </li>
                <li>
                  <Link
                    href="/app/end-customer-organizations"
                    onClick={toggle}
                    onKeyPress={toggle}
                    role="link"
                  >
                    Kundorganisationer
                  </Link>
                </li>
                <li>
                  <Link
                    href="/app/purchase-lists"
                    onClick={toggle}
                    onKeyPress={toggle}
                    role="link"
                  >
                    Favoritlistor
                  </Link>
                </li>
                <li>
                  <Link href="/app/jobs/?query[active]=true">Jobb</Link>
                </li>
                <li>
                  <Link href="/app/integrations/?query[active]=true">
                    Integrationer
                  </Link>
                </li>
                <li>
                  <Link href="/app/emails">Epost-logg</Link>
                </li>
                <li>
                  <Link href="/app/shop-configs/?query[active]=true">
                    Webbshop-konfigurationer
                  </Link>
                </li>
                <li>
                  <Link href="/app/supplier-connections/?query[active]=true">
                    Kundkopplingar
                  </Link>
                </li>
              </CollapseMenu>
            </RequiresRole>
          </ul>
        </div>
      </div>
    );
  }
}
const mapDispatchToProps = {
  toggleSidebar: _toggleSidebar,
};

const mapStateToProps = ({ authentication }) => ({
  sessionUser: authentication.sessionUser,
});
export default connect(mapStateToProps, mapDispatchToProps)(Sidebar);
